
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("2uJnW", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $1d1196aa7e0304b1$export$2cd8252107eb640b; });
// ====================================================================================
// sharing.module
// ====================================================================================
const $1d1196aa7e0304b1$export$2cd8252107eb640b = ()=>{
    const href = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title);
    document.querySelector(".btn--share-facebook").setAttribute("href", `https://www.facebook.com/sharer/sharer.php?u=${href}`);
    document.querySelector(".btn--share-twitter").setAttribute("href", `https://twitter.com/intent/tweet?text=${title}&url=${href}`);
    document.querySelector(".btn--share-linkedin").setAttribute("href", `https://www.linkedin.com/shareArticle?mini=true&url=${href}&title=${title}`);
    document.querySelector(".btn--share-xing").setAttribute("href", `https://www.xing.com/app/user?op=share&url=${href}`);
    document.querySelector(".btn--share-telegram").setAttribute("href", `https://telegram.me/share/url?url=${href}&text=${title}`);
    document.querySelector(".btn--share-whatsapp").setAttribute("href", `https://api.whatsapp.com/send?text=${title}%20${href}`);
    document.querySelector(".btn--share-mail").setAttribute("href", `mailto:?subject=${title}&body=${href}`);
};

});


//# sourceMappingURL=sharing.module.6a937779.js.map
